import React from 'react';
import { MLabel, MIcon } from 'src/theme';
import { PATH_CUSTOMER, PATH_CUSTOMER_APP_REVIEW } from 'src/routes/paths';

import HomeIcon from '@material-ui/icons/Home';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '@iconify/react';
import personIcon from '@iconify/icons-akar-icons/person';
import reportIcon from '@iconify/icons-carbon/report';
import buildingWarehouse from '@iconify/icons-tabler/building-warehouse';
// ----------------------------------------------------------------------

const path = (name) => `/static/icons/navbar/${name}.svg`;

const ICONS = {
  home: <Icon icon={reportIcon} style={{ width: '2em', height: '2em'}}/>,
  personIcon: <Icon icon={personIcon} style={{ width: '2em', height: '2em'}}/>,
  reportIcon: <Icon icon={reportIcon} style={{ width: '2em', height: '2em'}}/>,
  distributor: <Icon icon={buildingWarehouse} style={{ width: '2em', height: '2em'}}/>,
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'Profile',
        icon: ICONS.personIcon,
        href: PATH_CUSTOMER_APP_REVIEW.general.profile
      },
      {
        title: 'Retailer Application Form',
        icon: ICONS.reportIcon,
        href: PATH_CUSTOMER_APP_REVIEW.general.retailerApplicationForm
      },
      {
        title: 'distributor',
        icon: ICONS.distributor,
        href: PATH_CUSTOMER_APP_REVIEW.general.distributor
      }
    ]
  }
];

export default navConfig;
